/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Seo_Rate_RequestsInputs */

const en_seo_rate_requests = /** @type {(inputs: Seo_Rate_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} per 1,000 requests`)
};

const zh_hans1_seo_rate_requests = /** @type {(inputs: Seo_Rate_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每千次请求 ${i?.rate}`)
};

const pt_br2_seo_rate_requests = /** @type {(inputs: Seo_Rate_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por mil requisições`)
};

const es_seo_rate_requests = /** @type {(inputs: Seo_Rate_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por cada 1,000 solicitudes`)
};

const fr_seo_rate_requests = /** @type {(inputs: Seo_Rate_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pour 1 000 requêtes`)
};

const de_seo_rate_requests = /** @type {(inputs: Seo_Rate_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pro 1.000 Anfragen`)
};

const ru_seo_rate_requests = /** @type {(inputs: Seo_Rate_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} за 1000 запросов`)
};

const it_seo_rate_requests = /** @type {(inputs: Seo_Rate_RequestsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} ogni 1.000 richieste`)
};

/**
* | output |
* | --- |
* | "{rate} per 1,000 requests" |
*
* @param {Seo_Rate_RequestsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_rate_requests = /** @type {((inputs: Seo_Rate_RequestsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Rate_RequestsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_rate_requests(inputs)
	if (locale === "pt-BR") return pt_br2_seo_rate_requests(inputs)
	if (locale === "es") return es_seo_rate_requests(inputs)
	if (locale === "fr") return fr_seo_rate_requests(inputs)
	if (locale === "de") return de_seo_rate_requests(inputs)
	if (locale === "ru") return ru_seo_rate_requests(inputs)
	if (locale === "it") return it_seo_rate_requests(inputs)
	return en_seo_rate_requests(inputs)
});